import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const GET_CUSTOMER_MATCHES = gql`
  query GetCustomerMatches(
    $subcategoryId: String!
    $countryCode: String!
    $campaignId: String
    $visitorId: String!
    $answers: [AnswerInput]!
    $predefinedSupplierId: String
  ) {
    getCustomerMatches(
      subcategoryId: $subcategoryId
      countryCode: $countryCode
      campaignId: $campaignId
      visitorId: $visitorId
      answers: $answers
      useAbbeyBrands: true
      predefinedSupplierId: $predefinedSupplierId
    ) {
      customerMatches {
        brandId
        brandRevisionId
        brandFilterValue
        brandLabel
        brandLogoUrl
        requiresLegalStatementAboveNav
      }
      matchLevel
      maximumMatches
    }
  }
`;

const getCustomerMatchesQuery = async (params) => {
  const { variables } = params;
  try {
    const response = await query({
      query: GET_CUSTOMER_MATCHES,
      variables,
    });

    return response.data.getCustomerMatches;
  } catch (error) {
    throw new Error(error);
  }
};

export default getCustomerMatchesQuery;
